import { z } from 'zod'

export const zNullableOptionalDefault = <ItemType extends z.ZodTypeAny>(
  itemSchema: ItemType,
  defaultValue: z.infer<ItemType>
) => {
  return itemSchema
    .nullable()
    .optional()
    .transform(v => v ?? defaultValue)
}

export const zSafeString = (defaultValue = '') => zNullableOptionalDefault(z.string(), defaultValue)

export const zSafeBoolean = (defaultValue = false) =>
  zNullableOptionalDefault(z.boolean(), defaultValue)

export const zNullableOptionalUndefined = <ItemType extends z.ZodTypeAny>(itemSchema: ItemType) => {
  return itemSchema
    .nullable()
    .optional()
    .transform(v => v ?? undefined)
}
